import { useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { JourneyShell } from "@/components/journey/JourneyShell";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { useAuth } from "@/auth/AuthContext";
import { useJourneyContent } from "@/hooks/useJourneyContent";
import "@/pages/Journey.css";

const safeReturnTo = (value) => (value?.startsWith("/") ? value : "/account");

export default function SignIn() {
  const { user } = useAuth();
  const { ui, loading } = useJourneyContent();
  const [searchParams] = useSearchParams();
  const [consent, setConsent] = useState(false);
  const [showError, setShowError] = useState(false);
  const returnTo = safeReturnTo(searchParams.get("returnTo"));

  if (user) {
    const destination = returnTo === "/supplement-check" || user.profile_completed
      ? returnTo
      : `/profile?returnTo=${encodeURIComponent(returnTo)}`;
    return <Navigate to={destination} replace />;
  }
  if (loading || !ui) return <div className="journey-loading" data-testid="signin-loading-state" />;

  const beginGoogleSignIn = () => {
    if (!consent) {
      setShowError(true);
      return;
    }
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = `${window.location.origin}/auth/callback?returnTo=${encodeURIComponent(returnTo)}&consent=1`;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <JourneyShell>
      <section className="journey-panel journey-panel--narrow" data-testid="signin-panel">
        <span className="journey-icon" aria-hidden="true"><ShieldCheck /></span>
        <h1 data-testid="signin-title">{ui.login.title}</h1>
        <label className="journey-consent" data-testid="signin-consent-label">
          <Checkbox
            checked={consent}
            onCheckedChange={(value) => {
              setConsent(value === true);
              setShowError(false);
            }}
            data-testid="signin-consent-checkbox"
          />
          <span>{ui.login.consent_label}</span>
        </label>
        {showError && <p className="journey-error" data-testid="signin-consent-error">{ui.login.errors.consent}</p>}
        <Button onClick={beginGoogleSignIn} className={`journey-primary signin-google-action ${consent ? "is-ready" : "is-inactive"}`} data-testid="google-signin-button">
          {ui.verify.button}
        </Button>
      </section>
    </JourneyShell>
  );
}